<template>
	<div>

		<div class="main-page-content" style="margin-top: 20px">
			<el-tabs v-model="corp_type" type="card" @tab-click="handleClick">
				<el-tab-pane v-for="(item, index) in tabsList" :label="item.label" :key="index" :name="item.name"
					class="tab-item">
				</el-tab-pane>
			</el-tabs>

			<tzTable ref="apeTable" :data="dataList" :columns="columns" :loading="loadingStaus" :page="pagingData"
				@pageChange='init' :tableProps="{'highlight-current-row':true}">
				<!-- <template #signing='scope'>
					<div class="text">短信认证签约:<span>{{scope.row.esignsms_number}}</span>/ 条</div>
					<div>人脸识别认证签约:<span>{{scope.row.esignface_number}}</span>/ 次</div>
					<div>银行卡四要素认证签约:<span>{{scope.row.esignbank_number}}/ 次</span></div>
					<div>自定义电子合同:<span>{{scope.row.cont_number}}</span>/ 次</div>
				</template>
				<template #other='scope'>
					<div>短信通知类:<span>{{scope.row.sms_number}}</span>/ 条</div>
					<div>管理员角色:<span>{{scope.row.adm_number}}</span>/ 次</div>
					<div>人才库（超500人）:<span>{{scope}}</span></div>
					<div>智能算税:<span>{{scope.row.tax_number}}</span>/ 次</div>
				</template> -->
				<template #voucher='scope'>
					<div class="system-recharge">
						<div v-for="(item,index) in 3" :key='index'>
							<div class="system-recharge-item" v-if="scope.row['recharge_pic'+(index+1)]">
								<el-image :preview-src-list="[scope.row['recharge_pic'+(index+1)]]"
									style="width: 100px; height: 100px" :src="scope.row['recharge_pic'+(index+1)]"
									fit="fit">
								</el-image>
							</div>
						</div>
					</div>
				</template>
			</tzTable>
		</div>
	</div>
</template>

<script>
	import PageHeaderLayout from "@/layouts/PageHeaderLayout";
	import tzTable from "@/components/tz-table";


	export default {
		components: {
			PageHeaderLayout,
			tzTable,
		},
		props: ['id', 'type'],
		data() {
			return {
				loadingStaus: false,

				// 分页信息
				pagingData: {
					is_show: true,
					layout: "total, sizes, prev, pager, next, jumper",
					total: 0,
				},
				dataList: [],
				corp_type: '1',
				tabsList: [{
						label: "金额充值记录",
						name: "1",
					},
					{
						label: "套餐充值记录",
						name: "2",
					},
				],
				columns: [],
				money: [{
						label: "公司名称",
						prop: "company_name",

					},
					{
						label: "充值时间",
						prop: "created_at",

					},
					{
						label: "充值金额",
						prop: "money",

					},
					{
						label: "优惠金额",
						prop: "discount_amount",
					},
					{
						slot: true,
						name: 'voucher',
						label: "充值凭证",
						colProps: {
							width: '350'
						}
					}
				],
				set_meal: [{
						label: "公司名称",
						prop: "company_name",

					},
					{
						label: "充值时间",
						prop: "created_at",

					}, {
						label: "充值套餐",
						prop: "meal_name",

					},
					{
						label: "电子签约",
						type: 'textArray',
						name: 'signing',
						children:[
							{
								label:'短信认证签约:',
								prop: "esignsms_number",
								unit:' 条'
							},
							{
								label:'人脸识别认证签约:',
								prop: "esignface_number",
								unit:' 次'
							},
							{
								label:'银行卡四要素认证签约:',
								prop: "esignbank_number",
								unit:' 次'
							},{
								label:'自定义电子合同:',
								prop: "cont_number",
								unit:' 次'
							}
						]
					},
					{
						label: "其他费用",
						type: 'textArray',
						name: 'other',
						children:[
							{
								label:'短信通知类:',
								prop: "sms_number",
								unit:' 条'
							},
							{
								label:'管理员角色:',
								prop: "adm_number",
								unit:' 次'
							},
							{
								label:'人才库:',
								prop: "free_pool_meal_number",
								unit:' 次'
							},
							{
								label:'智能算税:',
								prop: "tax_number",
								unit:' 次'
							}
						]
					},
					{
						slot: true,
						name: 'voucher',
						label: "充值凭证",
						colProps: {
							width: '350'
						}
					}
				]
			};
		},

		methods: {
			// 重置分页
			async resetPage() {
				this.$refs.apeTable.currentPage = 1;
			},
			// 切换页码操作
			async switchPaging() {
				this.init();
			},
			//获取列表
			async init(page) {
				console.log(page)
				let pagingInfo =  {
					page_size: 10,
					current_page: 1,
					...page
				}
				this.loadingStaus = true;
				let request = 'postRecordRechargeList'
				/* 套餐充值 */
				if (this.corp_type == '2') {
					request = 'postRecordSet_mealRechargeList'
				}
				let res = await this.$api[request]({
					company_id: this.$props.id,
					company_type: this.$props.type,
					...pagingInfo
				})
				this.dataList = res.data || []
				this.pagingData.total = res.pages.total
				this.loadingStaus = false;
			},
			//点击tab切换
			async handleClick(tab) {
				this.corp_type = tab.name;
				if(tab.name=='2'){
					this.columns = this.set_meal
				}else{
					this.columns = this.money
				}
				
				this.init();
			},
		},

		mounted() {
			this.columns = this.money
			this.init()
		},
	};
</script>

<style lang="scss" scoped>
	.system-recharge {
		display: flex;
		justify-content: center;
	}

	.system-recharge-item {
		margin: 0 10px;
	}
</style>
